module.exports = __webpack_public_path__ + "img/problem-feedback.dfa4d467.svg";